import { Controller } from "@hotwired/stimulus"

// 切り替え時のちらつき防止用
let disconnectTimeout = null

// Connects to data-controller="task-browse-pane"
export default class extends Controller {
  static values = { taskId: Number }

  connect() {
    // 切り替え時: 前のdisconnectのタイムアウトをキャンセル
    if (disconnectTimeout) {
      clearTimeout(disconnectTimeout)
      disconnectTimeout = null
    }

    // コントローラーの祖先要素からどのwrapperを使用するか判定
    // SidePageComponent内にいる場合はside_page_wrapper、そうでなければstandalone用のwrapper
    const isInSidePage = this.element.closest('#side_page_wrapper')
    this.paneWrapper = isInSidePage ||
                       document.getElementById('task_browse_pane_wrapper')

    // standaloneの場合、side_pageが開いていればオフセット調整
    this.isStandalone = !isInSidePage && !!this.paneWrapper
    if (this.isStandalone) {
      this.#adjustSidePageOffset()
    }

    // wrapperを拡張してスライドイン（既に開いていれば何もしない）
    if (this.paneWrapper && !this.paneWrapper.classList.contains('task-browse-pane-open')) {
      requestAnimationFrame(() => {
        this.paneWrapper.classList.add('task-browse-pane-open')
      })
    }

    // 選択されたカードにfocusクラスを追加
    this.#updateFocusedCard()
  }

  dismiss(event) {
    event?.preventDefault()
    if (this.paneWrapper) {
      this.paneWrapper.classList.remove('task-browse-pane-open')
    }
    // standaloneの場合、side_pageのオフセットを戻す
    if (this.isStandalone) {
      this.#resetSidePageOffset()
    }
    // focusクラスを削除
    this.#removeFocusFromAllCards()
    // アニメーション完了後にturbo_frameをクリア
    setTimeout(() => {
      const frame = document.getElementById('task_browse_pane')
      if (frame) {
        frame.innerHTML = ''
      }
    }, 250)
  }

  disconnect() {
    const wrapper = this.paneWrapper
    const taskId = this.taskIdValue
    const isStandalone = this.isStandalone
    // 少し遅延させて、新しいconnectでキャンセルされるか確認
    disconnectTimeout = setTimeout(() => {
      if (wrapper) {
        wrapper.classList.remove('task-browse-pane-open')
      }
      // standaloneの場合、side_pageのオフセットを戻す
      if (isStandalone) {
        const sideWrapper = document.getElementById('side_page_wrapper')
        if (sideWrapper && sideWrapper.classList.contains('active')) {
          sideWrapper.style.right = '0px'
        }
      }
      // focusクラスを削除
      const card = document.querySelector(`.related-task-item[data-related-task-id="${taskId}"]`)
      if (card) {
        card.classList.remove('focus')
      }
      disconnectTimeout = null
    }, 50)
  }

  #updateFocusedCard() {
    // 全てのカードからfocusを削除
    this.#removeFocusFromAllCards()
    // 選択されたカードにfocusを追加
    const card = document.querySelector(`.related-task-item[data-related-task-id="${this.taskIdValue}"]`)
    if (card) {
      card.classList.add('focus')
    }
  }

  #adjustSidePageOffset() {
    const sideWrapper = document.getElementById('side_page_wrapper')
    if (sideWrapper && sideWrapper.classList.contains('active')) {
      // paneの幅を取得してside_pageをオフセット
      const paneContainer = this.paneWrapper.querySelector('#task_browse_pane_container')
      if (paneContainer) {
        // CSSトランジション後の幅を使うため少し遅延
        requestAnimationFrame(() => {
          setTimeout(() => {
            const paneWidth = paneContainer.offsetWidth
            sideWrapper.style.right = `${paneWidth}px`
          }, 300)
        })
      }
    }
  }

  #resetSidePageOffset() {
    const sideWrapper = document.getElementById('side_page_wrapper')
    if (sideWrapper && sideWrapper.classList.contains('active')) {
      sideWrapper.style.right = '0px'
    }
  }

  #removeFocusFromAllCards() {
    document.querySelectorAll('.related-task-item.focus').forEach(el => {
      el.classList.remove('focus')
    })
  }
}
